// extracted by mini-css-extract-plugin
export default {"metal":"Metal_metal__0jtM6","metal_order":"Metal_metal_order__RZPac","metal_wrap":"Metal_metal_wrap__DbpWu","metal_img":"Metal_metal_img__EpZy5"};